'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'sun';
var width = 576;
var height = 512;
var aliases = [9728];
var unicode = 'f185';
var svgPathData = ['M57.6 160.5l51.7 77.9c7.1 10.7 7.1 24.7 0 35.4l-51.7 77.9 91.6 18.5c12.6 2.6 22.5 12.4 25 25l18.5 91.6 77.9-51.7c10.7-7.1 24.7-7.1 35.4 0l77.9 51.7 18.5-91.6c2.6-12.6 12.4-22.5 25-25l91.6-18.5-51.7-77.9c-7.1-10.7-7.1-24.7 0-35.4l51.7-77.9-91.6-18.5c-12.6-2.6-22.5-12.4-25-25L383.8 25.3 306 77c-10.7 7.1-24.7 7.1-35.4 0l-77.9-51.7-18.5 91.6c-2.6 12.6-12.4 22.5-25 25L57.6 160.5zM399.7 256a111.7 111.7 0 1 1 -223.5 0 111.7 111.7 0 1 1 223.5 0z', 'M402.3 116.9c2.6 12.6 12.4 22.5 25 25l91.6 18.5-51.7 77.9c-7.1 10.7-7.1 24.7 0 35.4l51.7 77.9-91.6 18.5c-12.6 2.6-22.5 12.4-25 25L383.8 486.7 306 435c-10.7-7.1-24.7-7.1-35.4 0l-77.9 51.7-18.5-91.6c-2.6-12.6-12.4-22.5-25-25l-91.6-18.5 51.7-77.9c7.1-10.7 7.1-24.7 0-35.4l-51.7-77.9 91.6-18.5c12.6-2.6 22.5-12.4 25-25L192.7 25.3 270.6 77c10.7 7.1 24.7 7.1 35.4 0l77.9-51.7 18.5 91.6zM412.8 7.3C411-1.5 404.7-7.3 398.4-9.9s-14.9-3-22.4 2L288.3 50.3 200.5-7.9c-7.5-5-16-4.6-22.4-2S165.5-1.5 163.7 7.3L142.8 110.6 39.6 131.4c-8.8 1.8-14.6 8.1-17.2 14.4s-3 14.9 2 22.4L82.6 256 24.4 343.8c-5 7.5-4.6 16-2 22.4s8.4 12.6 17.2 14.4l103.2 20.9 20.9 103.2c1.8 8.8 8.1 14.6 14.4 17.2s14.9 3 22.4-2l87.8-58.2 87.8 58.2c7.5 5 16 4.6 22.4 2s12.6-8.4 14.4-17.2l20.9-103.2 103.2-20.9c8.8-1.8 14.6-8.1 17.2-14.4s3-14.9-2-22.4l-58.2-87.8 58.2-87.8c5-7.5 4.6-16 2-22.4s-8.4-12.6-17.2-14.4L433.7 110.6 412.8 7.3zM207.7 256a80.3 80.3 0 1 1 160.5 0 80.3 80.3 0 1 1 -160.5 0zm192.5 0a112.3 112.3 0 1 0 -224.5 0 112.3 112.3 0 1 0 224.5 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSun = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;